import downloadFiles, { downloadBase64, FILE_DOWNLOAD_TYPES } from '../utils/downloadFiles';
// eslint-disable-next-line import/no-cycle
import { getWeeklyReportAdapter } from '../adapters/weekly-report/get-weekly-report-adapter';
import { getWeeklyReportCalendarAdapter } from '../adapters/weekly-report/weekly-report-calendar-adapter';

import { api } from './apiInstances';

export const postDownloadFilesPt = async (oneFile, idParteDiario, idsArchivos, downloadType) => {
  /**
   * El backend solo puede recibir el parametro 2 para descargas individuales, por eso
   * hay que sobreescribir el downloadType por el 2 si el usuario quiere abrirlo en el navegador,
   */
  const shouldOpenInBrowser = downloadType === FILE_DOWNLOAD_TYPES.BROWSER;

  try {
    const result = await api.post(
      `/v2/PartesTrabajo/partesTrabajoDiario/adjuntos/download`,
      {
        idsPTDs: idParteDiario,
        idsArchivos,
        tipoDescarga: shouldOpenInBrowser ? 2 : downloadType
      },
      {
        headers: {
          Accept: '*/*'
        },
        responseType: 'blob'
      }
    );

    downloadFiles(result.data, oneFile, downloadType);

    return {
      success: true,
      data: result
    };
  } catch (e) {
    if (e.result) {
      throw new Error(e.result);
    } else {
      throw new Error('Estamos experimentando problemas, por favor, intente más tarde.');
    }
  }
};

// Create Work Report
export const postWorkReport = async (values) => {
  const result = await api.post('/v1/PartesTrabajo', values);

  return result.data;
};

// Get Work Report
export const getWorkReport = async (id) => {
  const result = await api.get(`/v1/PartesTrabajo?id=${id}`);

  return result.data;
};

// Post Work Report Lines
export const postLines = async (data) => {
  const result = await api.post(`/v1/PartesTrabajo/lineas`, data);

  return result.data;
};

// Update dates
export const putNewWorkReportDates = async (id, startDate, numberDates) => {
  const result = await api.put(
    `/v1/PartesTrabajo/${id}?fechaIncio=${startDate}&cantidadDias=${numberDates}`
  );

  return result.data;
};

// TODO: SOLO SE USA PARA TEST esta funcion
// GET lines by day
export const getLinesByDay = async (id, date, search, forceWindow) => {
  const url = `/v1/PartesTrabajo/${id}/lineasPorDia`;
  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fecha', date);
  }

  if (search) {
    uriParameters.append('buscar', search);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getLinesByDayV2 = async (id, body) => {
  const url = `/v1/PartesTrabajo/${id}/vistaDiaria`;

  const res = await api.post(url, body);

  return res.data;
};

export const getLineDataByDay = async (id, date) => {
  const result = await api.get(
    `v1/PartesTrabajo/${id}/partesTrabajoDiario/calendario?fechaConsulta=${date}`
  );

  return result.data;
};

// TODO: SOLO SE USA PARA TEST esta funcion
// GET lines by week
export const getLinesByWeek = async (id, date, search, forceWindow) => {
  const url = `/v1/PartesTrabajo/${id}/lineasSemana`;
  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fechaDesde', date);
  }

  if (search) {
    uriParameters.append('buscar', search);
  }

  uriParameters.append('forzarVentanaNotificacion', forceWindow === true);

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

export const getLinesByWeekNew = async (id, body) => {
  const url = `/v1/PartesTrabajo/${id}/vistaSemanal`;

  const res = await api.post(url, body);

  return res.data;
};

// GET total of line
export const getTotalOfLine = async (id) => {
  const result = await api.get(`/v1/PartesTrabajo/lineas/${id}/total`);

  return result.data;
};

// GET attachments of daily work report
export const getAttachmentsDaily = async (id) => {
  const result = await api.get(`/v1/PartesTrabajo/partesTrabajoDiario/${id}/adjuntos`);

  return result.data;
};

export const postSummaryPending = async (body) => {
  const result = await api.post(`v2/PartesTrabajo/partesTrabajoDiario/resumenPendientes`, body);

  return result.data;
};

export const downloadExcelSummaryPending = async (body) => {
  const result = await api.post(`v2/Reportes/resumenPartesPendientes/excel`, body, {
    headers: {
      Accept: '*/*'
    },
    responseType: 'base64'
  });

  if (result.errorMessage) {
    throw new Error(result.errorMessage);
  } else {
    downloadBase64(result.data, 'Resumen sup partes', 'xlsx');
  }
};
// Download attachments of daily work report
export const postDownloadAttachmentsDaily = async (id, body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/${id}/adjuntos/download`,
    body,
    {
      headers: {
        Accept: '*/*'
      },
      responseType: 'blob'
    }
  );

  return {
    success: true,
    data: result.data
  };
};

// Delete attachment of daily work report
export const deleteAttachmentsDaily = async (id, body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/${id}/adjuntos/deletion`,
    body
  );

  return result.data;
};

export const postAttachmentsDaily = async (id, body) => {
  const result = await api.post(`/v1/PartesTrabajo/partesTrabajoDiario/${id}/adjuntos`, body);

  return result.data;
};

// Download Work Report
export const downloadWorkReport = async (id) => {
  try {
    const result = await api.get(`/v1/PartesTrabajo/${id}/partesTrabajoDiario/download`, {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });

    if (result.errorMessage) {
      throw new Error(result.errorMessage);
    } else {
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', `parteDeTrabajoN°${id}.xlsx`);
      document.body.appendChild(link);
      link.click();

      return {
        success: true,
        data: result
      };
    }
  } catch (e) {
    if (e.result) {
      throw new Error(e.result);
    } else {
      throw new Error(
        e.status === 404
          ? `No se encuentran lineas para el parte de trabajo Id ${id}`
          : 'Estamos experimentando problemas, por favor, intente más tarde.'
      );
    }
  }
};

// Delete line
export const deleteLine = async (idPD) => {
  const result = await api.delete(`/v1/PartesTrabajo/lineas/partesTrabajoDiario/${idPD}`);

  return result.data;
};

// GET comments of an daily work report
export const getComments = async (id, skip, pageSizeParams, monthly) => {
  const pageSize = pageSizeParams ?? 10;
  const assignmentTypeQueryParam = monthly ? `&tipoAsignacion=3` : '';
  const baseUrl = '/v1/PartesTrabajo/partesTrabajoDiario';
  const result = await api.get(
    `${baseUrl}/${id}/comentarios?Skip=${skip}&PageSize=${pageSize}${assignmentTypeQueryParam}`
  );

  return result.data;
};

// POST a comment at daily work report
export const postComment = async (id, body, monthly) => {
  const assignmentTypeQueryParam = monthly ? `?tipoAsignacion=3` : '';
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/${id}/comentario${assignmentTypeQueryParam}`,
    body
  );

  return result.data;
};

// Send to approve lines
export const sendToApproveLines = async (id, data) => {
  const result = await api.put(`v1/PartesTrabajo/${id}/partesTrabajoDiario/cantidades`, data);

  return result.data;
};

// Rectify a line
export const rectifyALine = async (data) => {
  const result = await api.put(`v1/PartesTrabajo/partesTrabajoDiario/rectificacion`, data);

  return result.data;
};

// Approver Rectify lines
export const approverRectifyALine = async ({ id, cantidad, comentario }) => {
  const result = await api.patch(`v1/PartesTrabajo/partesTrabajoDiario/${id}`, {
    cantidad,
    comentario
  });

  return result.data.value;
};

export const approverRectifyLineWithPP = async (idParteDiario, body) => {
  const result = await api.patch(
    `v1/PartesTrabajo/partesTrabajoDiario/${idParteDiario}/puntosDePrograma`,
    body
  );

  return result.data;
};

export const cancelQuantity = async (data) => {
  const result = await api.put(`/v1/PartesTrabajo/partesTrabajoDiario/cancelacionCantidad`, data);

  return result.data;
};

export const getReferenceColors = async () => {
  const result = await api.get(`/v1/PartesTrabajo/vistaExtendida/coloresReferencia`);

  return result.data;
};

export const postImputation = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/imputacion/detalle`,
    body
  );

  return result.data;
};

export const putImputation = async (body, tipoImputacionId, objetoImputacionId) => {
  const result = await api.put(
    `/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/imputacion/detalle?tipoImputacionId=${tipoImputacionId}&objetoImputacionId=${objetoImputacionId}`,
    body
  );

  return result.data;
};

export const deleteFilesRequestPT = (idParteDiario, idsArchivos) =>
  api
    .post(`/v1/PartesTrabajo/partesTrabajoDiario/${idParteDiario}/adjuntos/deletion`, idsArchivos)
    .then((response) => ({
      success: true,
      data: response.data
    }))
    .catch((error) => ({
      success: false,
      message: error.message
    }));

export const getMonthlySummaryHeader = async (id, tipoAsignacion) => {
  const url = `/v1/PartesTrabajo/lineas/${id}/cabecera`;
  const uriParameters = new URLSearchParams();

  if (tipoAsignacion) {
    uriParameters.append('tipoAsignacion', tipoAsignacion);
  }
  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

// Get monthly summary of line
export const getMonthlySummary = async (id, date, monthly) => {
  const url = `/v1/PartesTrabajo/lineas/${id}/resumenMensual`;
  const uriParameters = new URLSearchParams();

  uriParameters.append('fecha', date);
  uriParameters.append('mensual', monthly);
  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

// Approve daily work reports
export const putApproveDailyWorkReports = async (version, body) => {
  const result = await api.put(`/${version}/PartesTrabajo/partesTrabajoDiario/aprobacion`, body);

  return result.data;
};

// GET typifications to ExpertReviewModal
export const getTypifications = async () => {
  const result = await api.get('/v1/PartesTrabajo/tipificaciones');

  return result.data;
};

// Mark daily work report for expert review
export const patchExpertReview = async (id, tipoAsignacionEnum, body) => {
  const result = await api.patch(
    `/v1/PartesTrabajo/partesTrabajoDiario/${id}/revisionExperta/${tipoAsignacionEnum}`,
    body
  );

  return result.data;
};

/** @param {number} id */
export const removeExpertReview = async (id) => {
  const { data } = await api.put(`/v1/PartesTrabajo/DesmarcarRevisionExperta?idParteDiario=${id}`);

  return data;
};

// GET Lines Month Header
export const getLinesMonthHeader = async (id, search) => {
  const baseUrl = `/v1/PartesTrabajo/${id}/lineasMesCabecera`;
  const params = new URLSearchParams();

  if (search) params.append('buscar', search);

  const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
  const result = await api.get(url);

  return result.data;
};

export const getDevolutionsDate = async (id) => {
  const result = await api.get(`/v1/PartesTrabajo/${id}/diasDevoluciones`);

  return result.data;
};

export const getCalendarLines = async (idWorkReportLine, date, goToFirstDay, goToLastDay) => {
  const url = `/v1/PartesTrabajo/${idWorkReportLine}/lineasMesAlmanaque`;
  const uriParameters = new URLSearchParams();

  if (date) {
    uriParameters.append('fechaInicio', date);
  }
  if (goToFirstDay) {
    uriParameters.append('primerLineaPendiente', true);
  }

  if (goToLastDay) {
    uriParameters.append('primerLineaPendiente', false);
  }

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};

// GET  Actions Components to InspectorExpertReviewModal
export const getActionComponents = async (idParteTrabajoDiario) => {
  const result = await api.get(`/v1/PartesTrabajo/revisionExperta/${idParteTrabajoDiario}`);

  return result.data;
};

// Delete Location in order by location
export const deleteUbication = async (id) => {
  const result = await api.delete(`/v1/PartesTrabajo/ubicacion/${id}`);

  return result.data;
};

export const deletePositionLine = async (id) => {
  const result = await api.delete(`/v1/PartesTrabajo/linea/${id}`);

  return result.data;
};

export const deletePositionLineOrUbication = async (id) => {
  const result = await api.delete(`/v1/PartesTrabajo/ubicacionLinea/${id}`);

  return result.data;
};

export const getWorkReportsApprover = async (filters, date, isPending) => {
  const baseUrl = `v2/PartesTrabajo/partesTrabajoDiario`;
  const result = await api.post(
    `${baseUrl}/aprobador?fecha=${date}&pendiente=${isPending}`,
    filters
  );

  return result.data;
};

export const postHeadboardApprover = async (date, isPending, body) => {
  const baseUrl = '/v2/PartesTrabajo/cabeceraAprobador';
  const result = await api.post(`${baseUrl}?fecha=${date}&pendiente=${isPending}`, body);

  return result.data;
};

export const getfilterPreferenceApprover = async () => {
  const result = await api.get(`/v1/PartesTrabajo/aprobador/filtro/supervision`);

  return result.data;
};

export const postFilterPreferenceApprover = async (filters) => {
  const result = await api.post('/v1/PartesTrabajo/preferenciasAprobador', filters);

  return result.data;
};

// Conseguir la información para resumen de solicitud
export const getTotalSummary = async (idparteTrabajo) => {
  const result = await api.get(`/v1/PartesTrabajo/${idparteTrabajo}/resumensolicitudServicio`);

  return result.data;
};

// Conseguir la información para resumen de solicitud mensualizado
export const getTotalMonthlySummary = async (line) => {
  const result = await api.get(`/v1/PartesTrabajo/${line}/resumensolicitudServicioMensualizada`);

  return result.data;
};

// Obtener lista de motivos
export const getMotivesLowScore = async () => {
  const result = await api.get(`/v1/SolicitudesServicio/MotivoBajaCalificacion`);

  return result.data;
};

/**
 * @typedef WeeklyReportFilters
 * @property {number[]} contratosIds
 * @property {boolean} partesVisualizar
 */

/** @param {{fechaSeleccionada: string, pageNumber?: number, sortType: import("../components/WeeklyReportTable/hooks/useSort").SortType, filtros: WeeklyReportFilters, isInspector: boolean, cancelToken: import("axios").CancelTokenSource}} */
export const getWeeklyWorkReport = async ({
  fechaSeleccionada,
  pageNumber = 1,
  sortType,
  filtros = { contratosIds: [], partesVisualizar: true },
  isInspector,
  cancelToken
}) => {
  const body = {
    agrupaPorUbicacion: sortType === 'location',
    fechaSeleccionada,
    pagination: {
      pageNumber,
      pageSize: 15
    },
    filtros
  };

  const API_URL = isInspector
    ? '/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/inspector'
    : '/v2/PartesTrabajo/partesTrabajoDiario/vistaSimplificada';

  const { data } = await api.post(API_URL, body, {
    cancelToken: cancelToken?.token
  });

  return getWeeklyReportAdapter(data);
};

export const getWeeklyReportCalendar = async () => {
  const { data } = await api.get('v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/calendario');

  return getWeeklyReportCalendarAdapter(data);
};

/**
 * @param {{partesDiariosIds: number[]}} body
 * @param {boolean} isInspector
 */
export const approveWorkReports = async (body, isInspector) => {
  const { partesDiariosIds } = body;

  const { data } = isInspector
    ? await api.patch('/v1/PartesTrabajo/partesTrabajoDiario/autorizacionCantidad', body)
    : await api.put('/v1/PartesTrabajo/partesTrabajoDiario/aprobacion', partesDiariosIds);

  return data;
};

export const downloadExcelWorkReports = async ({ date, isPending, filters }) => {
  const result = await api.post(
    `v1/PartesTrabajo/partesTrabajoDiario/download?pendiente=${isPending}&fecha=${date}`,
    filters,
    {
      headers: {
        Accept: '*/*'
      },
      responseType: 'blob'
    }
  );

  const url = window.URL.createObjectURL(new Blob([result.data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `reportes-${date}.xlsx`);
  document.body.appendChild(link);
  link.click();

  return {
    success: true,
    data: result.data
  };
};

/** @param {{isMonthly: boolean, requestID: number}} */
export const finishService = async ({ isMonthly, requestID }) => {
  const body = { comentario: null };

  const { data } = isMonthly
    ? await api.put(`/v1/SolicitudesServicioMensualizada/${requestID}/finalizacion`, body)
    : await api.put(`/v1/SolicitudesServicio/${requestID}/finalizacion`, body);

  return data;
};

/** @param {{ idPartesDiario: number[], agrupaPorUbicacion: boolean}} */
export const getUbicationsHeaderData = async (idsPartesDiario, agrupaPorUbicacion) => {
  const body = { idsPartesDiario, agrupaPorUbicacion };

  const { data } = await api.post(
    '/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/pxq/cabecera',
    body
  );

  return data;
};

/** @param {{ idParteDiario: number, isInspector: boolean}} */
export const getWeeklyReportActions = async (idParteDiario, isInspector) => {
  const URL = isInspector
    ? `/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/menu?idParteDiario=${idParteDiario}`
    : `/v1/PartesTrabajo/partesTrabajoDiario/vistaSimplificada/menu?idParteDiario=${idParteDiario}`;

  const { data } = await api.get(URL);

  return data;
};

export const getFilesDownloadOptions = async () => {
  const { data } = await api.get('/v1/ServiciosArchivoAdjunto/tipoDescarga');

  return data;
};

export const getDetailsEventsWeeklyReport = async (nroSolicitud) => {
  const result = await api.get(`/v1/SolicitudesServicio/${nroSolicitud}/evento`);

  return result.data;
};

/**
 * @param {{partesDiariosIds: number[]}} body
 */
export const rejectWorkReports = async (body) => {
  const { partesDiariosIds } = body;

  const { data } = await api.put(
    'v1/PartesTrabajo/partesTrabajoDiario/rechazoMasivo',
    partesDiariosIds
  );

  return data;
};

export const getProgramPoints = async (id) => {
  const result = await api.get(`/v1/PartesTrabajo/partesTrabajoDiario/${id}/puntosDePrograma`);

  return result.data;
};

export const postProgramPoint = async (id, body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/${id}/puntosDePrograma`,
    body
  );

  return result.data;
};

export const getProgramPointsWithPPFijado = async (idParteDiario) => {
  const result = await api.get(
    `/v1/PartesTrabajo/partesTrabajoDiario/${idParteDiario}/fijado/puntosDePrograma`
  );

  return [result.data];
};

// Supporting Document
export const postSupportingDocument = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parte-diario/documento-respaldo/posicion-linea`,
    body
  );

  return result.data;
};

export const deleteSupportingDocument = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parte-diario/documento-respaldo/posicion-linea/quitar-existente`,
    body
  );

  return result.data;
};

export const verifySupportingDocument = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parte-diario/documento-respaldo/posicion-linea/validacion`,
    body
  );

  return result.data;
};

// Supporting Document Multiple
export const postSupportingDocumentMultiple = async (body) => {
  const result = await api.post(`/v1/PartesTrabajo/parte-diario/documento-respaldo/masivo`, body);

  return result.data;
};

export const deleteSupportingDocumentMultiple = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parte-diario/documento-respaldo/masivo/quitar-existente`,
    body
  );

  return result.data;
};

export const verifySupportingDocumentMultiple = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parte-diario/documento-respaldo/masivo/validacion`,
    body
  );

  return result.data;
};

export const getOperationalDetails = async (idParteDiario, body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parteDiario/${idParteDiario}/desplegablesOperativos`,
    body
  );

  return result.data;
};

export const getCSDefault = async (idParteDiario, body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/parteDiario/${idParteDiario}/detalleOperativoPredeterminado`,
    body
  );

  return result.data;
};
export const getImputationObjectVEApprover = async (body) => {
  const result = await api.post(
    `/v1/PartesTrabajo/partesTrabajoDiario/vistaExtendida/imputacion/detalle/aprobador`,
    body
  );

  return result.data;
};

export const updateimputationObjectMSDSApprover = async ({ idSolicitud, idUbicacion }, body) => {
  const parseBody = body?.map((data) => ({
    ...data,
    ParteTrabajoDiarioIds: []
  }));
  const result = await api.patch(
    `/v1/SolicitudesServicioMensualizada/${idSolicitud}/ubicaciones/${idUbicacion}/objetosImputacion/aprobador`,
    parseBody
  );

  return result.data;
};

export const updateImputationObjectSDSApprover = async (idSolicitud, body) => {
  const result = await api.patch(
    `/v1/SolicitudesServicio/${idSolicitud}/objetosImputacion/aprobador`,
    body
  );

  return result.data;
};

export const getClasificationApprover = async (fase, evento) => {
  const uriParameters = new URLSearchParams();
  const url = `/v1/PartesTrabajo/ClasesPorFaseYEvento`;

  if (fase) {
    uriParameters.append('fase', evento === 'PRF' ? '*' : fase);
  }

  if (evento) {
    uriParameters.append('evento', evento);
  }

  const newURL = url.concat(`?${uriParameters.toString()}`);
  const result = await api.get(newURL);

  return result.data;
};
